// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterMenu_wrapper__OvKNc"};